import axios from "axios";
import { nuclearn_api_url } from "src/App";

export interface UploadLimits {
  max_concurrent_uploads: number;
  configuration: {
    global_limit: number;
    per_user_limit: number | null;
    per_dataset_limit: number | null;
  };
  recommendations: {
    frontend_concurrent_limit: number;
    retry_after_seconds: number;
    max_retry_attempts: number;
  };
}

// Cache the limits for the session
let cachedLimits: UploadLimits | null = null;

/**
 * Fetch upload limits from the backend
 * @returns Upload limits configuration
 */
export const fetchUploadLimits = async (): Promise<UploadLimits> => {
  // Return cached limits if available
  if (cachedLimits) {
    return cachedLimits;
  }

  try {
    const response = await axios.get<UploadLimits>(
      `${nuclearn_api_url}/management/upload-limits`,
    );

    cachedLimits = response.data;
    return cachedLimits;
  } catch (error) {
    console.error("Failed to fetch upload limits, using defaults:", error);

    // Return default limits if fetch fails
    const defaultLimits: UploadLimits = {
      max_concurrent_uploads: 10,
      configuration: {
        global_limit: 10,
        per_user_limit: null,
        per_dataset_limit: null,
      },
      recommendations: {
        frontend_concurrent_limit: 10,
        retry_after_seconds: 5,
        max_retry_attempts: 3,
      },
    };

    return defaultLimits;
  }
};
